import { useEditingStateWithCtx } from '@/atoms'
import { FormActionButton } from '@workwave-tidal/core/form'
import * as texts from '../../../intl'
import { form } from '../formState'
import { emptySimulationId } from '../utils'

export function Footer() {
  const { resetEditing } = useEditingStateWithCtx('simulation')
  const { field: idField } = form.useFormField('id')

  const {
    meta: { submitting, validating, status },
  } = form.useFormMeta()

  const saveDisabled =
    idField.value === emptySimulationId
      ? validating || submitting
      : status === 'pristine' || validating || submitting

  return (
    <>
      <FormActionButton
        label={texts.getCancelText()}
        size="medium"
        testId="footer-secondary-button"
        data-trackid="footer-secondary-button"
        onClick={resetEditing}
      />
      <FormActionButton
        label={
          idField.value == emptySimulationId ? texts.getFormSaveText() : texts.getEditSaveText()
        }
        size="medium"
        type="submit"
        testId="footer-primary-button"
        data-trackid="footer-primary-button"
        variant="contained"
        loading={submitting || validating}
        disabled={saveDisabled}
      />
    </>
  )
}
